import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { FormlyFieldConfig, FormlyFormOptions } from '@ngx-formly/core';

import { FormlyService } from '../../services';

@Component({
  selector: 'app-base-form',
  templateUrl: './base-form.component.html',
  styleUrl: './base-form.component.scss',
})
export class BaseFormComponent implements OnInit, AfterViewInit {
  @Input() fields: FormlyFieldConfig[];
  @Input() model: any = {};
  @Input() mobile = false;
  @Input() saveText: string;
  @Input() focusFieldIndex: number;
  @Output() save = new EventEmitter<any>();

  form: UntypedFormGroup = new UntypedFormGroup({});
  options: FormlyFormOptions = {};

  constructor(private formlyService: FormlyService) {}

  ngOnInit(): void {
    if (this.saveText) {
      this.fields.push(
        this.formlyService.button(this.saveText, () => this.save.emit(this.model), { mobile: this.mobile }, undefined, {
          'props.disabled': () => this.form.invalid,
        }),
      );
    }
  }

  ngAfterViewInit(): void {
    if (this.focusFieldIndex >= 0) {
      this.focusField(this.focusFieldIndex);
    }
  }

  updateModel(model: any, markUpdated = true, markUnchanged = false) {
    this.model = { ...this.model, ...model };
    if (markUpdated) {
      this.form.markAsDirty();
      this.form.markAllAsTouched();
    }
    if (markUnchanged) {
      this.form.markAsPristine();
      this.form.markAsUntouched();
    }
  }

  focusField(focusFieldIndex: number) {
    this.fields[focusFieldIndex].focus = true;
  }
}
